// extracted by mini-css-extract-plugin
module.exports = {"root":"TenderId_root__13n9E"};